export default "__VITE_ASSET__CwESXRIh__"